export function hexToRgb(hex: string): [number, number, number] | false {
  hex = (hex || '').replace(/^#/, '').trim()

  let r: string, g: string, b: string
  if (hex.length == 3) {
    r = hex.substring(0, 1)
    r += r
    g = hex.substring(1, 2)
    g += g
    b = hex.substring(2, 3)
    b += b
  } else if (hex.length === 6) {
    r = hex.substring(0, 2)
    g = hex.substring(2, 4)
    b = hex.substring(4, 6)
  } else {
    return false
  }

  const rInt = parseInt(r, 16)
  const gInt = parseInt(g, 16)
  const bInt = parseInt(b, 16)

  if (isNaN(rInt) || isNaN(gInt) || isNaN(bInt)) {
    return false
  }

  return [rInt, gInt, bInt]
}

export function rgbToHex(r: number, g: number, b: number): string {
  return '#' + decToHex(r) + decToHex(g) + decToHex(b)
}

function decToHex(d: number): string {
  return String('00' + Math.round(d).toString(16)).slice(-2)
}

export function rgbToHsv(
  r: number,
  g: number,
  b: number
): [number, number, number] {
  r /= 255
  g /= 255
  b /= 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h: number, s: number
  const v = max

  const d = max - min
  s = max == 0 ? 0 : d / max

  if (max == min) {
    h = 0 // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
      default:
        h = 0
    }

    h /= 6
  }

  return [h, s, v]
}

export function hsvToRgb(
  h: number,
  s: number,
  v: number
): [number, number, number] {
  let r: number, g: number, b: number

  const i = Math.floor(h * 6)
  const f = h * 6 - i
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)

  switch (i % 6) {
    case 0:
      r = v
      g = t
      b = p
      break
    case 1:
      r = q
      g = v
      b = p
      break
    case 2:
      r = p
      g = v
      b = t
      break
    case 3:
      r = p
      g = q
      b = v
      break
    case 4:
      r = t
      g = p
      b = v
      break
    case 5:
      r = v
      g = p
      b = q
      break
    default:
      r = 0
      g = 0
      b = 0
  }

  return [r * 255, g * 255, b * 255]
}

export function fontColorForBackground(hex: string): string {
  const rgb = hexToRgb(hex)
  if (!rgb) {
    return '#000'
  }
  const [r, g, b] = rgb
  const avg = (r + g + b) / 3
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const isYellow = r > 100 && r < g * 1.25 && g > b * 1.25
  if ((max > 100 && min < 180 && avg < 180 && !isYellow) || avg < 100) {
    return '#fff'
  } else {
    return '#000'
  }
}

export function blendConfigBg(hex: string): string {
  const gray = 210
  const rgb = hexToRgb(hex)
  if (!rgb) {
    return '#e4e5e6'
  }
  let [r, g, b] = rgb
  r = (r + gray) / 2
  g = (g + gray) / 2
  b = (b + gray) / 2
  return rgbToHex(r, g, b)
}

export function isLetter(input: string): boolean {
  const ral = `${input}`
  return /^[A-Z]/i.test(ral)
}
